import { Component } from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import { TrackingHOC } from 'hocs'
import { selectQuery } from '../App/selectors'
import Suggest from './Suggest'
import { fetchSuggestions } from './actions'
import SearchForm from 'components/Subheader/Form'

class SearchInput extends Component {
  state = { search: '' }

  componentDidMount() {
    const query = this.props.query.q
    if (query && query.trim() !== '') {
      this.setState({ search: query })
      // this.search(query)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const query = nextProps.query.q
    if (this.props.query.q !== query && !query) {
      this.setState({ search: '' })
    }
  }

  onInputChange = (e, { newValue, method }) => {
    this.setState({ search: newValue })
    if (newValue && method === 'type' && newValue.trim().length > 1) {
      // this.searchQuery(newValue)
      this.props.fetchSuggestions(newValue)
      this.trackSearch(newValue, 'revise')
    }
  }

  handleSubmit = (e) => {
    e.preventDefault()
    if (this.state.search.trim() !== '') {
      this.trackSearch(this.state.search, 'submit')
      browserHistory.push(`/search?q=${encodeURIComponent(this.state.search)}`)
      // Remove focus from search input to hide suggestions
      document.activeElement.blur()
    }
  }

  handleSelect = (event, { suggestion }) => {
    this.setState({ search: suggestion })
    this.trackSearch(suggestion, 'select_suggestion')
    browserHistory.push(`/search?q=${encodeURIComponent(suggestion)}`)
  }

  handleClear = () => {
    this.setState({ search: '' })
  }

  trackSearch = (query, action) => {
    this.props.createEvent({
      category: 'search',
      data: { action, search_term: query }
    })
  }

  render() {
    const suggestionProps = {
      ...this.props,
      ...this.state,
      onChange: this.onInputChange,
      value: this.state.search,
      handleSelect: this.handleSelect,
      handleClear: this.handleClear
    }

    return (
      <SearchForm onSubmit={this.handleSubmit.bind(this)}>
        <Suggest {...suggestionProps} />
      </SearchForm>
    )
  }
}

const mapStateToProps = (state) => ({
  query: selectQuery(state),
  ...state.search
})

const mapDispatchToProps = (dispatch) => ({
  fetchSuggestions: (query) => dispatch(fetchSuggestions.request(query))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrackingHOC(SearchInput))
